// ==================================================================================== GLOBAL 2
// Set
gsap.set('.co-global-section-2-left', { y: 20, transition: 0, opacity: 0 });
gsap.set('.co-global-section-2-right', { x: 10, transition: 0, opacity: 0 });
gsap.set('.co-global-section-2-right-wrapper', { y: 10, transition: 0, opacity: 0 });
// Timeline
let co_global_sec_2_tl = gsap.timeline({ paused: true });
// To
co_global_sec_2_tl.to('.co-global-section-2-left', {
  y: 0, opacity: 1, ease: "power2.inOut", duration: 1
});
co_global_sec_2_tl.to('.co-global-section-2-right', {
  x: 0, opacity: 1, ease: "power2.inOut", duration: 1
}, '-=0.75');
co_global_sec_2_tl.to('.co-global-section-2-right-wrapper', {
  y: 0, opacity: 1, ease: "power2.inOut", duration: 1
}, '-=0.95');
// Trigger
ScrollTrigger.create({
  // markers: true,
  trigger: '.co-global-section-2', start:'top bottom', end: "bottom bottom", animation: co_global_sec_2_tl
});
// SCROLL
gsap.set('.co-global-section-2-left-image', { top: "0%", transition: 0 });
gsap.to('.co-global-section-2-left-image', {
  scrollTrigger: {
    trigger: '.co-global-section-2-left', start:'top bottom', end: "bottom top", scrub: 1.25
  },
  top: "-10%"
});
// gsap.set('.co-global-section-2-right-image', { left: "0%", transition: 0 });
// gsap.to('.co-global-section-2-right-image', {
//   scrollTrigger: {
//     trigger: '.co-global-section-2-right', start:'top bottom', end: "bottom top", scrub: 1.25
//   },
//   left: "-5%"
// });
// ==================================================================================== SEARCH
let coSearchButton = document.querySelector('.co-blog-search-button');
coSearchButton.addEventListener('click', function(e) {
  e.preventDefault();
  setTimeout(function() {
      document.querySelector('.header__icon--search').click();
  }, 100);
});
// ==================================================================================== FILTER
// POPUP
let coShopSection3OpenButton = document.querySelector('.co-blog-filter-button');
let coShopSection3CloseButton = document.querySelector('#co-shop-section-3-close-button-id');
let coShopSection3 = document.querySelector('#co-shop-section-3-id');
let coShopSection3Body = document.querySelector('body');
let coShopSection3Animate = document.querySelector('.co-shop-section-3-animate');
coShopSection3OpenButton.addEventListener('click', function(e) {
  e.preventDefault();
  if (!coShopSection3.classList.contains('co-shop-section-3-active')) {
    coShopSection3.classList.add('co-shop-section-3-active');
  }
  if (!coShopSection3Body.classList.contains('co-overflow-hidden')) {
    coShopSection3Body.classList.add('co-overflow-hidden');
  }
  if (!coShopSection3OpenButton.classList.contains('co-active')) {
    setTimeout(function() {
      coShopSection3OpenButton.classList.add('co-active');
    }, 50);
  }
  if (!coShopSection3Animate.classList.contains('co-shop-section-3-animate-active')) {
    setTimeout(function() {
      coShopSection3Animate.classList.add('co-shop-section-3-animate-active');
    }, 50);
  }    
});
coShopSection3CloseButton.addEventListener('click', function(e) {
  e.preventDefault();
  if (coShopSection3.classList.contains('co-shop-section-3-active')) {
    coShopSection3.classList.remove('co-shop-section-3-active');
  }
  if (coShopSection3Body.classList.contains('co-overflow-hidden')) {
    coShopSection3Body.classList.remove('co-overflow-hidden');
  }
  if (coShopSection3OpenButton.classList.contains('co-active')) {
    coShopSection3OpenButton.classList.remove('co-active');
  }
  if (coShopSection3Animate.classList.contains('co-shop-section-3-animate-active')) {
    setTimeout(function() {
      coShopSection3Animate.classList.remove('co-shop-section-3-animate-active');
    }, 50);
  }    
});